import * as React from 'react';

import { MapServices } from '../../../../components/Map/parts';
import { EMapService } from '../../../../types/map';
import { useMapServices } from './hooks';

export interface IMapServicesContainerProps {
  onServiceClick: (service: EMapService) => void;
}

export const MapServicesContainer: React.FC<IMapServicesContainerProps> = ({ onServiceClick }) => {
  const serviceTypes = useMapServices();

  return <MapServices onServiceClick={onServiceClick} serviceTypes={serviceTypes} />;
};
